module.exports = __webpack_public_path__ + "static/img/headerImg.5cc0f427.png";